import type { InputSearchOptionType } from '@c4-links/vue3-links-components';
import { FilterDefinitionValueSearchType } from '@carrefour-gcs/bff-sdk';

export const getSearchInputOptions = (
  t: (key: string) => string
): (InputSearchOptionType & { value: FilterDefinitionValueSearchType })[] => [
  {
    icon: 'search',
    value: FilterDefinitionValueSearchType.CONTAINS,
    label: t('filters.form.search.contains.label'),
    dynamicField: {
      type: 'text',
      placeholder: t('filters.form.search.contains.placeholder')
    }
  },
  {
    icon: 'search',
    value: FilterDefinitionValueSearchType.STARTS_WITH,
    label: t('filters.form.search.startsWith.label'),
    dynamicField: {
      type: 'text',
      placeholder: t('filters.form.search.startsWith.placeholder')
    }
  },
  {
    icon: 'search',
    value: FilterDefinitionValueSearchType.ENDS_WITH,
    label: t('filters.form.search.endsWith.label'),
    dynamicField: {
      type: 'text',
      placeholder: t('filters.form.search.endsWith.placeholder')
    }
  },
  {
    icon: 'tag',
    value: FilterDefinitionValueSearchType.MULTISELECT,
    label: t('filters.form.search.multiselect.label'),
    dynamicField: {
      type: 'tag',
      placeholder: t('filters.form.search.multiselect.placeholder')
    }
  }
];
